import { NgxLoadingButtonsModule } from 'ngx-loading-buttons';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayContainer } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TranslationModule } from '@lib/translation';
import { SnCommonModule } from '@lib/common';
import { SnFormModule } from '@lib/form';
import { SnFormFileUploadModule } from '@lib/form/file-upload';
import { SnFormSelectModule } from '@lib/form/select';
import { GoogleMapModule } from '@lib/geo/google/map';
import { SnMapModule } from '@lib/geo/map';
import { SnShareModule } from '@lib/share';
import { SnStatsModule } from '@lib/stats';
import { SnTagsModule } from '@lib/tags';
import { SnActionsModule } from '@lib/ui/actions';
import { SnButtonModule } from '@lib/ui/button';
import { SnDataListModule } from '@lib/ui/data-list';
import { SnDrawerModule } from '@lib/ui/drawer';
import { SnIconModule } from '@lib/ui/icon';
import { SnListModule } from '@lib/ui/list';
import { SnMenuModule } from '@lib/ui/menu';
import { ExistingFullscreenOverlayContainer } from '@lib/ui/overlay';
import { SnSearchbarModule } from 'libs/ui/searchbar/src/lib/searchbar.module';

import {
  SnFloorListComponent,
  SnFloorRangeComponent,
  LocationListComponent,
  LocationTableComponent,
  LocationDetailsComponent,
  LocationMapComponent,
  LocationMediaListComponent,
  LocationMediaListItemComponent,
  ConfirmLocationPlaceDialogComponent,
} from './components';
import { LocationMediaDialogComponent } from './components/location-media-dialog/location-media-dialog.component';
import { LocationMediaDrawerComponent } from './components/location-media-drawer';
import { LocationMediaContainer } from './components/location-media/location-media.container';
import { LocationSearchDialogComponent } from './components/location-search-dialog/location-search-dialog.component';

@NgModule({
  imports: [
    // Angulag
    CommonModule,
    FormsModule,
    // CDK
    DragDropModule,
    // Material
    MatSortModule,
    MatTableModule,
    MatSliderModule,
    MatTooltipModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatCheckboxModule,
    MatRippleModule,
    MatButtonModule,
    NgxLoadingButtonsModule,
    // Libs
    SnMapModule,
    SnTagsModule,
    SnListModule,
    SnDataListModule,
    SnMenuModule,
    SnShareModule,
    SnIconModule,
    SnShareModule,
    SnStatsModule,
    SnButtonModule,
    SnActionsModule,
    SnFormModule,
    SnFormFileUploadModule,
    SnFormSelectModule,
    SnDrawerModule,
    NgxLoadingButtonsModule,
    SnCommonModule,
    SnSearchbarModule,
    // Map
    GoogleMapModule,
    MatPaginatorModule,
    MatSelectModule,
    TranslationModule,
  ],

  exports: [
    // Components
    SnFloorListComponent,
    SnFloorRangeComponent,
    LocationListComponent,
    LocationTableComponent,
    LocationDetailsComponent,
    LocationMapComponent,
    LocationMediaListComponent,
    LocationSearchDialogComponent,
    LocationMediaListItemComponent,
    LocationMediaContainer,
    LocationMediaDialogComponent,
    LocationMediaDrawerComponent,
    ConfirmLocationPlaceDialogComponent,
  ],
  declarations: [
    // Components
    SnFloorListComponent,
    SnFloorRangeComponent,
    LocationListComponent,
    LocationTableComponent,
    LocationDetailsComponent,
    LocationMapComponent,
    LocationMediaListComponent,
    LocationMediaListItemComponent,
    LocationMediaContainer,
    LocationMediaDialogComponent,
    LocationSearchDialogComponent,
    LocationMediaDrawerComponent,
    ConfirmLocationPlaceDialogComponent,
  ],
  providers: [{ provide: OverlayContainer, useClass: ExistingFullscreenOverlayContainer }],
})
export class SnLocationsModule {}
